export default {
    key: "markentry",
    type: "markentry",
    protected: false,
    persistent: true,
    markEntryFor:"",
    markEntryType:"SUBJECT",
    label:"",
    subjectConf:{
      numberOfSubject:12,
      enableIsCore:false,
      displaySubjectBy:"TABLE",
      relateWithEligibilityRule:false
    },
    semesterYearConf:{
      cognateFieldEnabled:false,
      numberOfSubjects:6,
      isLanguageFieldEnabled:false,
      numberOfYearOrSemester:6,
      semesters:[
        {
          name:"Semester 1",
          noOfRequiredField:0,
          id:1
        },
        {
          name:"Semester 2",
          noOfRequiredField:0,
          id:2
        },
        {
          name:"Semester 3",
          noOfRequiredField:0,
          id:3
        },
        {
          name:"Semester 4",
          noOfRequiredField:0,
          id:4
        },
        {
          name:"Semester 5",
          noOfRequiredField:0,
          id:5
        },
        {
          name:"Semester 6",
          noOfRequiredField:0,
          id:6
        }
      ]
    },
    editOnce:false,
    required:false
  };
  